import React, { FC } from 'react';

import { Dropdown, Tooltip } from 'antd';

// Shared UI Library Components
import {
  CustomIcon,
  EIconName,
  CustomTag
} from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './specialty-specialisations-card.scss';

// Models
import { ISpecialtySpecialisations } from '../../../../interfaces/company.interfaces';

type TSpecialtySpecialisationsCardProps = {
  info: ISpecialtySpecialisations;
  editItem?: (info: ISpecialtySpecialisations) => void;
  deleteItem?: (info: ISpecialtySpecialisations) => void;
};

export const SpecialtySpecialisationsCard: FC<TSpecialtySpecialisationsCardProps> = (
  {
    info: { speciality, specializations },
    editItem = () => {},
    deleteItem = () => {},
  }: TSpecialtySpecialisationsCardProps
) => {

  const dropdownItems = [
    {
      key: 'edit',
      label: (
        <div className="user-menu--item">
          <CustomIcon name={ EIconName.Edit } size={ 'size-lg' }/>
          Edit
        </div>),
      onClick: () => editItem({ speciality, specializations })
    },
    {
      key: 'delete',
      label: (
        <div className="user-menu--item">
          <CustomIcon name={ EIconName.Delete } size={ 'size-lg' }/>
          Delete
        </div>),
      onClick: () => deleteItem({ speciality, specializations })
    },
  ];

  return (
    <div className="specialty-specialisations-card">
      <div className="specialty-specialisations-card--header">
        <div className="header-title">
          { speciality.name }
        </div>
        <div className="header-action">
          <Dropdown
            rootClassName={ 'user-menu--menu' }
            menu={ { items: dropdownItems } } trigger={ ['click'] } placement="bottomRight" arrow>
            <CustomIcon name={ EIconName.BurgerMenu }/>
          </Dropdown>
        </div>
      </div>
      <div className="specialty-specialisations-card--content">
        { specializations.map(({ id, name }) => <Tooltip key={ id }
                                                         title={ name }><CustomTag>{ name }</CustomTag></Tooltip>) }
      </div>
    </div>
  );
}
